
import SignIn from './views/account/signin.vue'
import Home from './views/Home.vue'
import One_Order_List from './views/One_Order_List.vue'
import Last_Orders from './views/Last_Orders.vue'
import Noahs_Orders_Only from './views/Noahs_Orders_Only.vue'
import Samples_Only from './views/Samples_Only.vue'
import Hidden_List from './views/Hidden_List.vue'

import Compare from './views/Compare.vue'
import Web_Accounts from './views/Web_Accounts.vue'
import Calls from './views/Calls.vue'
import Sleep from './views/Sleep.vue'
import Vape from './views/Vape.vue'

import LFB_Graph from './views/LFB_Graph.vue'

import Roads from './views/Roads.vue'
import RoadsDetails from './views/Roads_Details.vue'
import CA_Map from './views/CA_Map.vue'


import Noahs_Orders from './views/Noahs_Orders.vue'
import Hard8th_Orders from './views/Hard8th_Orders.vue'
import Pack_Orders from './views/14Pack_Orders.vue'

import Customer_Details from './views/Customer_Details.vue'
import Customer_Multiple from './views/Customer_Multiple.vue'

import Vegas from './views/Vegas.vue'
import Vegas_New from './views/Vegas_New.vue'

import One_Plant from './views/OnePlant.vue'
import EwcSgi from './views/EwcSgi.vue'


import Account_Receivables from './views/Account_Receivables.vue'
import Account_Receivables_Detail from './views/Account_Receivables_Detail.vue'
import Account_Receivables_Log from './views/Account_Receivables_Log.vue'

import Prospects from './views/Prospects.vue'
import Prospect_Detail from './views/Prospect_Detail.vue'
import Commission from './views/Commission.vue'

import Account_Agents from './views/Account_Agents.vue'

import Pistil_History from './views/Pistil_History.vue'



import Froot_Wheel_Detail from './views/FrootWheel/Froot_Wheel_Detail.vue'
import Froot_Wheel_Winners from './views/FrootWheel/Froot_Wheel_Winners.vue'
import Froot_Wheel_Triggers from './views/FrootWheel/Froot_Wheel_Triggers.vue'


let routes = [
    {
        path: '/',
        name: 'home',
        component: Home,
        meta: { requiresLogin: true },
    },
    {
        path: '/account/signin',
        name: 'signin',
        component: SignIn,
        meta: { requiresLogin: false },
    },
    {
        path: '/one_order_list',
        name: 'one_order_list',
        component: One_Order_List,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/last_orders',
        name: 'last_orders',
        component: Last_Orders,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/noahs_orders_only',
        name: 'noahs_orders_only',
        component: Noahs_Orders_Only,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/noahs_orders',
        name: 'noahs_orders',
        component: Noahs_Orders,
        props: true,
        meta: { requiresLogin: true },
    },

    {
        path: '/14pack_orders',
        name: '14pack_orders',
        component: Pack_Orders,
        props: true,
        meta: { requiresLogin: true },
    },

    {
        path: '/hard8th_orders',
        name: 'hard8th_orders',
        component: Hard8th_Orders,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/sleep',
        name: 'sleep',
        component: Sleep,
        meta: { requiresLogin: true },
    },
    {
        path: '/vape',
        name: 'vape',
        component: Vape,
        meta: { requiresLogin: true },
    },
    {
        path: '/lfb_graph',
        name: 'lfb_graph',
        component: LFB_Graph,
        meta: { requiresLogin: true },
    },
    {
        path: '/samples_only',
        name: 'samples_only',
        component: Samples_Only,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/hidden_list',
        name: 'hidden_list',
        component: Hidden_List,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/customer_details',
        name: 'customer_details',
        component: Customer_Details,
        props: true,  /// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        meta: { requiresLogin: true },
    },
    {
        path: '/customer_multiple',
        name: 'customer_multiple',
        component: Customer_Multiple,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/vegas',
        name: 'vegas',
        component: Vegas,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/vegas_new',
        name: 'vegas_new',
        component: Vegas_New,
        props: false,
        meta: { requiresLogin: true },
    },
    
    
    
    {
        path: '/one_plant',
        name: 'one_plant',
        component: One_Plant,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/ewc_sgi',
        name: 'ewc_sgi',
        component: EwcSgi,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/account_receivables',
        name: 'account_receivables',
        component: Account_Receivables,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/account_receivables_log',
        name: 'account_receivables_log',
        component: Account_Receivables_Log,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/compare',
        name: 'compare',
        component: Compare,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/web_accounts',
        name: 'web_accounts',
        component: Web_Accounts,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/calls',
        name: 'calls',
        component: Calls,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/roads',
        name: 'roads',
        component: Roads,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/roads_details',
        name: 'roads_details',
        component: RoadsDetails,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/ca_map',
        name: 'ca_map',
        component: CA_Map,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/account_receivables_detail',
        name: 'account_receivables_detail',
        component: Account_Receivables_Detail,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/prospects',
        name: 'prospects',
        component: Prospects,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/prospect_detail',
        name: 'prospect_detail',
        component: Prospect_Detail,
        props: true,
        meta: { requiresLogin: true },
    },
    {
        path: '/commission',
        name: 'commission',
        component: Commission,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/account_agents',
        name: 'account_agents',
        component: Account_Agents,
        props: false,
        meta: { requiresLogin: true },
    },
    {
        path: '/pistil_history',
        name: 'pistil_history',
        component: Pistil_History,
        props: true,
        meta: { requiresLogin: true },
    },


    {
        path: '/froot_wheel_detail',
        name: 'froot_wheel_detail',
        component: Froot_Wheel_Detail,
        meta: { requiresLogin: true },
    },
    {
        path: '/froot_wheel_winners',
        name: 'froot_wheel_winners',
        component: Froot_Wheel_Winners,
        meta: { requiresLogin: true },
    },
    {
        path: '/froot_wheel_triggers',
        name: 'froot_wheel_triggers',
        component: Froot_Wheel_Triggers,
        meta: { requiresLogin: true },
    },


];

export default routes;
